/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useState } from 'react'
import { AppContext } from '../context/AppContext'
import { getRequestOptions } from '../helpers/Fetchwrapper'
import Swal from 'sweetalert2'

const CustomerList = () => {
    const { currentUser } = useContext(AppContext)
    const [customers, setCustomers] = useState([])
    const [loading, setLoading] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [filterStatus, setFilterStatus] = useState('all')
    const [currentPage, setCurrentPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [selectedCustomer, setSelectedCustomer] = useState(null)
    const [showCustomerModal, setShowCustomerModal] = useState(false)
    const [showAddressModal, setShowAddressModal] = useState(false)
    const [showDetailsModal, setShowDetailsModal] = useState(false)
    const [showEditCustomerModal, setShowEditCustomerModal] = useState(false)
    const [showEditAddressModal, setShowEditAddressModal] = useState(false)
    const [isEditing, setIsEditing] = useState(false)
    const [customerDetails, setCustomerDetails] = useState(null)
    const [detailsLoading, setDetailsLoading] = useState(false)
    const [editingAddress, setEditingAddress] = useState(null)
    const [areas, setAreas] = useState([])
    const [pagination, setPagination] = useState({
        current_page: 1,
        per_page: 10,
        total: 0,
        total_pages: 0,
        has_next_page: false,
        has_prev_page: false,
        from: 0,
        to: 0
    })

    // Form states
    const [customerForm, setCustomerForm] = useState({
        firstname: '',
        lastname: '',
        email: '',
        mobile_no: '',
        gender: '',
        dob: '',
        password: '',
        is_active: true,
        ispCustomerId: ''
    })

    const [addressForm, setAddressForm] = useState({
        customer_id: '',
        firstname: '',
        lastname: '',
        company: '',
        house: '',
        street: '',
        block: '',
        area: '',
        region: 'Chittagong',
        postcode: '',
        phone_number: '',
        floor_no: '',
        apartment_no: '',
        is_default_shipping: false,
        is_default_billing: false
    })

    useEffect(() => {
        fetchCustomers()
    }, [currentPage, searchTerm, filterStatus, itemsPerPage])

    useEffect(() => {
        const fetchAreas = () => {
            if (addressForm.region) {
                fetch(process.env.REACT_APP_API_URL + `areas/${addressForm.region}`, getRequestOptions())
                    .then((resp) => resp.json())
                    .then((resp) => {
                        if (resp.success) {
                            const tempArray = resp.data.map((element) => ({
                                label: element.name,
                                value: element.name,
                            }))
                            setAreas(tempArray)
                        }
                    })
                    .catch((error) => console.log("Error fetching areas:", error))
            } else {
                setAreas([])
            }
        }

        fetchAreas()
    }, [addressForm.region])

    const fetchCustomers = () => {
        setLoading(true)
        
        const params = new URLSearchParams({
            page: currentPage.toString(),
            per_page: itemsPerPage.toString(),
            search: searchTerm,
            status: filterStatus,
            sort_by: 'created_at',
            sort_order: 'desc'
        })

        fetch(process.env.REACT_APP_API_URL + "customers_list?" + params.toString(), getRequestOptions())
            .then((resp) => resp.json())
            .then((resp) => {
                if (resp.success) {
                    setCustomers(resp.data || [])
                    setPagination(resp.pagination || {
                        current_page: 1,
                        per_page: 10,
                        total: 0,
                        total_pages: 0,
                        has_next_page: false,
                        has_prev_page: false,
                        from: 0,
                        to: 0
                    })
                } else {
                    console.error('Failed to fetch customers:', resp.errorMessage)
                    setCustomers([])
                }
            })
            .catch((error) => {
                console.error('Error fetching customers:', error)
                setCustomers([])
            })
            .finally(() => {
                setLoading(false)
            })
    }

    const handleSearchChange = (value) => {
        setSearchTerm(value)
        setCurrentPage(1)
    }

    const handleFilterChange = (type, value) => {
        if (type === 'status') {
            setFilterStatus(value)
        } else if (type === 'perPage') {
            setItemsPerPage(parseInt(value))
        }
        setCurrentPage(1)
    }

    const handlePageChange = (page) => {
        setCurrentPage(page)
        window.scrollTo({ top: 0, behavior: 'smooth' })
    }

    const getStatusBadge = (isActive) => {
        return isActive ? 'bg-success' : 'bg-danger'
    }

    const formatDate = (dateString) => {
        if (!dateString) return 'N/A'
        const date = new Date(dateString)
        const options = { 
            year: 'numeric', 
            month: 'long', 
            day: 'numeric' 
        }
        return date.toLocaleDateString('en-GB', options)
    }

    const openAddCustomerModal = () => {
        setCustomerForm({
            firstname: '',
            lastname: '',
            email: '',
            mobile_no: '',
            gender: '',
            dob: '',
            password: '',
            is_active: true,
            ispCustomerId: ''
        })
        setIsEditing(false)
        setShowCustomerModal(true)
    }

    const openAddAddressModal = (customer) => {
        setAddressForm({
            customer_id: customer.id,
            firstname: customer.firstname || '',
            lastname: customer.lastname || '',
            company: '',
            house: '',
            street: '',
            block: '',
            area: '',
            region: 'Chittagong',
            postcode: '',
            phone_number: customer.mobile_no || '',
            floor_no: '',
            apartment_no: '',
            is_default_shipping: false,
            is_default_billing: false
        })
        setSelectedCustomer(customer)
        setShowAddressModal(true)
    }

    const handleCustomerFormChange = (field, value) => {
        setCustomerForm(prev => ({
            ...prev,
            [field]: value
        }))
    }

    const handleAddressFormChange = (field, value) => {
        setAddressForm(prev => 
            field === "region"
                ? { ...prev, area: "", [field]: value }
                : { ...prev, [field]: value }
        )
    }

    const submitCustomer = async () => {
        try {
            setLoading(true)
            
            // Log the data being sent for debugging
            console.log('Sending customer data:', customerForm)
            
            const url = isEditing 
                ? process.env.REACT_APP_API_URL + `customers_update/${customerDetails.id}`
                : process.env.REACT_APP_API_URL + 'customers_create'
            
            const response = await fetch(url, {
                method: isEditing ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getRequestOptions().headers
                },
                body: JSON.stringify(customerForm)
            })
            
            const result = await response.json()
            console.log('API Response:', result)
            
            if (result.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: isEditing ? 'Customer updated successfully!' : 'Customer created successfully!',
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
                
                setShowCustomerModal(false)
                closeEditCustomerModal()
                
                if (isEditing) {
                    // Refresh customer details if editing
                    viewCustomerDetails(selectedCustomer)
                }
                fetchCustomers()
            } else {
                // Handle validation errors
                if (result.errorMessage && typeof result.errorMessage === 'object') {
                    let errorMsg = ''
                    Object.keys(result.errorMessage).forEach(field => {
                        errorMsg += `• ${field}: ${result.errorMessage[field].join(', ')}<br>`
                    })
                    Swal.fire({
                        icon: 'error',
                        title: 'Validation Errors',
                        html: errorMsg,
                        confirmButtonColor: '#d33'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `Failed to ${isEditing ? 'update' : 'create'} customer: ` + (result.errorMessage || result.message || 'Unknown error'),
                        confirmButtonColor: '#d33'
                    })
                }
            }
        } catch (error) {
            console.error(`Error ${isEditing ? 'updating' : 'creating'} customer:`, error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: `Error ${isEditing ? 'updating' : 'creating'} customer. Please try again.`,
                confirmButtonColor: '#d33'
            })
        } finally {
            setLoading(false)
        }
    }

    const submitAddress = async () => {
        const isEditingAddress = editingAddress !== null
        
        try {
            setLoading(true)
            
            const url = isEditingAddress 
                ? process.env.REACT_APP_API_URL + `customers_address_update/${editingAddress.id}`
                : process.env.REACT_APP_API_URL + 'customers_address_create'
            
            const response = await fetch(url, {
                method: isEditingAddress ? 'PUT' : 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getRequestOptions().headers
                },
                body: JSON.stringify(addressForm)
            })
            
            const result = await response.json()
            
            if (result.success) {
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: isEditingAddress ? 'Address updated successfully!' : 'Customer address created successfully!',
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
                
                setShowAddressModal(false)
                closeEditAddressModal()
                
                if (isEditingAddress) {
                    // Refresh customer details if editing
                    viewCustomerDetails(selectedCustomer)
                }
                fetchCustomers()
            } else {
                // Handle validation errors for address
                if (result.errorMessage && typeof result.errorMessage === 'object') {
                    let errorMsg = ''
                    Object.keys(result.errorMessage).forEach(field => {
                        errorMsg += `• ${field}: ${result.errorMessage[field].join(', ')}<br>`
                    })
                    Swal.fire({
                        icon: 'error',
                        title: 'Validation Errors',
                        html: errorMsg,
                        confirmButtonColor: '#d33'
                    })
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: `Failed to ${isEditingAddress ? 'update' : 'create'} address: ` + (result.errorMessage || result.message || 'Unknown error'),
                        confirmButtonColor: '#d33'
                    })
                }
            }
        } catch (error) {
            console.error(`Error ${isEditingAddress ? 'updating' : 'creating'} address:`, error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: `Error ${isEditingAddress ? 'updating' : 'creating'} address. Please try again.`,
                confirmButtonColor: '#d33'
            })
        } finally {
            setLoading(false)
        }
    }

    const toggleCustomerStatus = async (customer) => {
        try {
            setLoading(true)
            const response = await fetch(process.env.REACT_APP_API_URL + `customers_status_update/${customer.id}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    ...getRequestOptions().headers
                },
                body: JSON.stringify({ is_active: !customer.is_active })
            })
            
            const result = await response.json()
            
            if (result.success) {
                setCustomers(customers.map(c => 
                    c.id === customer.id 
                        ? { ...c, is_active: !c.is_active, status: !c.is_active ? 'Active' : 'Inactive' }
                        : c
                ))
                Swal.fire({
                    icon: 'success',
                    title: 'Success!',
                    text: `Customer ${!customer.is_active ? 'activated' : 'deactivated'} successfully!`,
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to update customer status: ' + (result.errorMessage || result.message || 'Unknown error'),
                    confirmButtonColor: '#d33'
                })
            }
        } catch (error) {
            console.error('Error updating customer status:', error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: 'Error updating customer status. Please try again.',
                confirmButtonColor: '#d33'
            })
        } finally {
            setLoading(false)
        }
    }

    const viewCustomerDetails = async (customer) => {
        try {
            setDetailsLoading(true)
            const response = await fetch(process.env.REACT_APP_API_URL + `customers_details/${customer.id}`, getRequestOptions())
            const result = await response.json()
            
            if (result.success) {
                setCustomerDetails(result.data)
                setSelectedCustomer(customer)
                setShowDetailsModal(true)
                console.log('Customer details:', result.data)
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Error',
                    text: 'Failed to fetch customer details: ' + (result.errorMessage || result.message || 'Unknown error'),
                    confirmButtonColor: '#d33'
                })
            }
        } catch (error) {
            console.error('Error fetching customer details:', error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: 'Error fetching customer details. Please try again.',
                confirmButtonColor: '#d33'
            })
        } finally {
            setDetailsLoading(false)
        }
    }

    const openEditCustomerModal = () => {
        if (customerDetails) {
            setCustomerForm({
                firstname: customerDetails.firstname || '',
                lastname: customerDetails.lastname || '',
                email: customerDetails.email || '',
                mobile_no: customerDetails.mobile_no || '',
                gender: customerDetails.gender || '',
                dob: customerDetails.dob || '',
                password: '',
                is_active: customerDetails.is_active || true
            })
            setIsEditing(true)
            setShowEditCustomerModal(true)
        }
    }

    const openEditAddressModal = (address) => {
        setEditingAddress(address)
        setAddressForm({
            customer_id: customerDetails.id,
            firstname: address.firstname || '',
            lastname: address.lastname || '',
            company: address.company || '',
            house: address.house || '',
            street: address.street || '',
            block: address.block || '',
            area: address.area || '',
            region: address.region || 'Chittagong',
            postcode: address.postcode || '',
            phone_number: address.phone_number || '',
            floor_no: address.floor_no || '',
            apartment_no: address.apartment_no || '',
            is_default_shipping: address.is_default_shipping || false,
            is_default_billing: address.is_default_billing || false
        })
        setShowEditAddressModal(true)
    }

    const closeEditCustomerModal = () => {
        setShowEditCustomerModal(false)
        setIsEditing(false)
        setCustomerForm({
            firstname: '',
            lastname: '',
            email: '',
            mobile_no: '',
            gender: '',
            dob: '',
            password: '',
            is_active: true,
            ispCustomerId: ''
        })
    }

    const closeEditAddressModal = () => {
        setShowEditAddressModal(false)
        setEditingAddress(null)
        setAddressForm({
            customer_id: '',
            firstname: '',
            lastname: '',
            company: '',
            house: '',
            street: '',
            block: '',
            area: '',
            region: 'Chittagong',
            postcode: '',
            phone_number: '',
            floor_no: '',
            apartment_no: '',
            is_default_shipping: false,
            is_default_billing: false
        })
    }

    const findCustomerFromBilling = async () => {
        if (!customerForm.ispCustomerId) {
            Swal.fire({
                icon: 'warning',
                title: 'Warning',
                text: 'Please enter an ISP Customer ID',
                confirmButtonColor: '#3085d6'
            })
            return
        }

        try {
            setLoading(true)
            const response = await fetch(`${process.env.REACT_APP_BILL_API_URL}customer_details/${customerForm.ispCustomerId}`)
            const result = await response.json()
            
            if (result && result.id) {
                // Auto-fill the form with billing data
                setCustomerForm(prev => ({
                    ...prev,
                    firstname: result.name || '',
                    email: result.email || '',
                    mobile_no: result.mobileNo || '',
                    // Keep other fields as they are
                }))
                
                Swal.fire({
                    icon: 'success',
                    title: 'Customer Found!',
                    text: `Customer details loaded for ID: ${result.id}`,
                    confirmButtonColor: '#3085d6',
                    timer: 2000,
                    showConfirmButton: false
                })
            } else {
                Swal.fire({
                    icon: 'error',
                    title: 'Customer Not Found',
                    text: 'No customer found with the provided ISP Customer ID',
                    confirmButtonColor: '#d33'
                })
            }
        } catch (error) {
            console.error('Error fetching customer from billing:', error)
            Swal.fire({
                icon: 'error',
                title: 'Connection Error',
                text: 'Error fetching customer details. Please try again.',
                confirmButtonColor: '#d33'
            })
        } finally {
            setLoading(false)
        }
    }

    return (
        <>
            <div className='card card-custom'>
                <div className='card-header card-header-mobile'>
                    <div className='card-title'>
                        <h3 className='card-label'>Customer Management</h3>
                    </div>
                    <div className='card-toolbar card-toolbar-mobile'>
                        <button 
                            className='btn btn-primary btn-mobile me-2'
                            onClick={openAddCustomerModal}
                            disabled={loading}
                        >
                            <i className="fas fa-plus"></i>
                            <span className="btn-text">Add Customer</span>
                        </button>
                        <button 
                            className='btn btn-secondary btn-mobile'
                            onClick={fetchCustomers}
                            disabled={loading}
                        >
                            {loading ? (
                                <>
                                    <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                    <span className="btn-text">Loading...</span>
                                </>
                            ) : (
                                <>
                                    <i className="fas fa-sync-alt"></i>
                                    <span className="btn-text">Refresh</span>
                                </>
                            )}
                        </button>
                    </div>
                </div>

                <div className='card-body'>
                    {/* Filters */}
                    <div className='filters-container filters-container-mobile mb-4'>
                        {/* Mobile Filters */}
                        <div className='d-lg-none mobile-filters'>
                            <div className='mobile-search-wrapper mb-3'>
                                <div className="position-relative">
                                    <input
                                        type='text'
                                        className='form-control form-control-mobile-search'
                                        placeholder='Search customers...'
                                        value={searchTerm}
                                        onChange={(e) => handleSearchChange(e.target.value)}
                                       
                                    />
                                    <div className="search-icon-mobile">
                                        <i className="fas fa-search"></i>
                                    </div>
                                    {loading && (
                                        <div className="search-loading-mobile">
                                            <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                <span className="visually-hidden">Searching...</span>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                            
                            <div className='mobile-filter-row'>
                                <div className='mobile-filter-item'>
                                    <label className='filter-label-mobile'>Status</label>
                                    <select
                                        className='form-select form-select-mobile'
                                        value={filterStatus}
                                        onChange={(e) => handleFilterChange('status', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Status</option>
                                        <option value='active'>Active</option>
                                        <option value='inactive'>Inactive</option>
                                    </select>
                                </div>
                                <div className='mobile-filter-item'>
                                    <label className='filter-label-mobile'>Show</label>
                                    <select
                                        className='form-select form-select-mobile'
                                        value={itemsPerPage}
                                        onChange={(e) => handleFilterChange('perPage', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value={10}>10</option>
                                        <option value={20}>20</option>
                                        <option value={50}>50</option>
                                        <option value={100}>100</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Desktop Filters */}
                        <div className='d-none d-lg-block'>
                            <div className='row'>
                                <div className='col-md-4'>
                                    <div className="position-relative">
                                        <input
                                            type='text'
                                            className='form-control'
                                            placeholder='Search customers by name, email, or mobile...'
                                            value={searchTerm}
                                            onChange={(e) => handleSearchChange(e.target.value)}
                                            disabled={loading}
                                        />
                                        {loading && (
                                            <div className="position-absolute top-50 end-0 translate-middle-y me-3">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status">
                                                    <span className="visually-hidden">Searching...</span>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className='col-md-3'>
                                    <select
                                        className='form-select'
                                        value={filterStatus}
                                        onChange={(e) => handleFilterChange('status', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value='all'>All Status</option>
                                        <option value='active'>Active</option>
                                        <option value='inactive'>Inactive</option>
                                    </select>
                                </div>
                                <div className='col-md-2'>
                                    <select
                                        className='form-select'
                                        value={itemsPerPage}
                                        onChange={(e) => handleFilterChange('perPage', e.target.value)}
                                        disabled={loading}
                                    >
                                        <option value={10}>10 per page</option>
                                        <option value={20}>20 per page</option>
                                        <option value={50}>50 per page</option>
                                        <option value={100}>100 per page</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Results Summary */}
                    <div className='row mb-3'>
                        <div className='col-12'>
                            <div className='text-muted small'>
                                {pagination.total > 0 ? (
                                    <>
                                        Showing {pagination.from}-{pagination.to} of {pagination.total} customers
                                    </>
                                ) : (
                                    'No customers found'
                                )}
                            </div>
                        </div>
                    </div>

                    {/* Customer List - Desktop Table / Mobile Cards */}
                    <div className='customer-list-container'>
                        {/* Desktop Table View */}
                        <div className='d-none d-lg-block'>
                            <div className='table-responsive'>
                                <table className='table table-striped table-hover'>
                                    <thead className='table-dark'>
                                        <tr>
                                            <th>ISP Customer ID</th>
                                            <th>Name</th>
                                            <th>Email</th>
                                            <th>Mobile</th>
                                            <th>Gender</th>
                                            <th>Status</th>
                                            <th>Addresses</th>
                                            <th>Joined</th>
                                            <th>Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {loading ? (
                                            <tr>
                                                <td colSpan='9' className='text-center py-4'>
                                                    <div className="spinner-border text-primary" role="status">
                                                        <span className="visually-hidden">Loading...</span>
                                                    </div>
                                                    <p className="mt-2">Loading customers...</p>
                                                </td>
                                            </tr>
                                        ) : customers.length === 0 ? (
                                            <tr>
                                                <td colSpan='9' className='text-center py-4'>
                                                    <div className='text-muted'>
                                                        <i className='fas fa-users fa-3x mb-3'></i>
                                                        <p>No customers found</p>
                                                    </div>
                                                </td>
                                            </tr>
                                        ) : (
                                            customers.map((customer) => (
                                                <tr key={customer.id}>
                                                    <td>
                                                        <span className='badge bg-primary text-white'>
                                                            {customer.isp_customer_id || 'N/A'}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <div>
                                                            <strong>{customer.full_name}</strong>
                                                            <small className='text-muted d-block'>#{customer.id}</small>
                                                        </div>
                                                    </td>
                                                    <td>{customer.email || 'N/A'}</td>
                                                    <td>{customer.mobile_no}</td>
                                                    <td>
                                                        {customer.gender ? (
                                                            <span className='badge bg-light text-dark'>
                                                                {customer.gender.charAt(0).toUpperCase() + customer.gender.slice(1)}
                                                            </span>
                                                        ) : 'N/A'}
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${getStatusBadge(customer.is_active)}`}>
                                                            {customer.status}
                                                        </span>
                                                    </td>
                                                    <td>
                                                        <span className={`badge ${customer.has_addresses ? 'bg-info' : 'bg-secondary'}`}>
                                                            {customer.has_addresses ? 'Has Address' : 'No Address'}
                                                        </span>
                                                    </td>
                                                    <td>{formatDate(customer.created_at)}</td>
                                                    <td>
                                                        <div className='btn-group btn-group-sm'>
                                                            <button
                                                                className='btn btn-outline-primary'
                                                                onClick={() => viewCustomerDetails(customer)}
                                                                title='View Details'
                                                                disabled={detailsLoading}
                                                            >
                                                                <i className='fas fa-eye'></i>
                                                            </button>
                                                            <button
                                                                className='btn btn-outline-success'
                                                                onClick={() => openAddAddressModal(customer)}
                                                                title='Add Address'
                                                            >
                                                                <i className='fas fa-map-marker-alt'></i>
                                                            </button>
                                                            <button
                                                                className={`btn btn-outline-${customer.is_active ? 'warning' : 'success'}`}
                                                                onClick={() => toggleCustomerStatus(customer)}
                                                                title={customer.is_active ? 'Deactivate' : 'Activate'}
                                                            >
                                                                <i className={`fas fa-${customer.is_active ? 'ban' : 'check'}`}></i>
                                                            </button>
                                                        </div>
                                                    </td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Mobile Card View */}
                        <div className='d-lg-none'>
                            {loading ? (
                                <div className='text-center py-5'>
                                    <div className="spinner-border text-primary" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                    <p className="mt-2">Loading customers...</p>
                                </div>
                            ) : customers.length === 0 ? (
                                <div className='text-center py-5'>
                                    <div className='text-muted'>
                                        <i className='fas fa-users fa-3x mb-3'></i>
                                        <p>No customers found</p>
                                    </div>
                                </div>
                            ) : (
                                <div className='customer-cards'>
                                    {customers.map((customer) => (
                                        <div 
                                            key={customer.id} 
                                            className='customer-card'
                                        >
                                            <div className='customer-card-header'>
                                                <div className='customer-name'>
                                                    <strong>{customer.full_name}</strong>
                                                    <div className='customer-ids'>
                                                        <small className='text-muted d-block'>ID: #{customer.id}</small>
                                                        {customer.isp_customer_id && (
                                                            <span className='badge bg-primary text-white mt-1'>
                                                                ISP: {customer.isp_customer_id}
                                                            </span>
                                                        )}
                                                    </div>
                                                </div>
                                                <div className='customer-status'>
                                                    <span className={`badge ${getStatusBadge(customer.is_active)}`}>
                                                        {customer.status}
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div className='customer-card-body'>
                                                <div className='customer-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-envelope me-2'></i>Email:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        {customer.email || 'N/A'}
                                                    </span>
                                                </div>
                                                
                                                <div className='customer-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-phone me-2'></i>Mobile:
                                                    </span>
                                                    <span className='info-value-mobile font-monospace'>
                                                        {customer.mobile_no}
                                                    </span>
                                                </div>
                                                
                                                {customer.gender && (
                                                    <div className='customer-info-row'>
                                                        <span className='info-label-mobile'>
                                                            <i className='fas fa-venus-mars me-2'></i>Gender:
                                                        </span>
                                                        <span className='info-value-mobile'>
                                                            <span className='badge bg-light text-dark'>
                                                                {customer.gender.charAt(0).toUpperCase() + customer.gender.slice(1)}
                                                            </span>
                                                        </span>
                                                    </div>
                                                )}
                                                
                                                <div className='customer-info-row'>
                                                    <span className='info-label-mobile'>
                                                        <i className='fas fa-map-marker-alt me-2'></i>Addresses:
                                                    </span>
                                                    <span className='info-value-mobile'>
                                                        <span className={`badge ${customer.has_addresses ? 'bg-info' : 'bg-secondary'}`}>
                                                            {customer.has_addresses ? 'Has Address' : 'No Address'}
                                                        </span>
                                                    </span>
                                                </div>
                                            </div>
                                            
                                            <div className='customer-card-footer'>
                                                <div className='customer-date'>
                                                    <i className='fas fa-calendar me-2 text-muted'></i>
                                                    <small className='text-muted'>
                                                        Joined: {formatDate(customer.created_at)}
                                                    </small>
                                                </div>
                                                <div className='customer-actions'>
                                                    <button
                                                        className='btn btn-sm btn-outline-primary me-1'
                                                        onClick={() => viewCustomerDetails(customer)}
                                                        title='View Details'
                                                        disabled={detailsLoading}
                                                    >
                                                        <i className='fas fa-eye'></i>
                                                    </button>
                                                    <button
                                                        className='btn btn-sm btn-outline-success me-1'
                                                        onClick={() => openAddAddressModal(customer)}
                                                        title='Add Address'
                                                    >
                                                        <i className='fas fa-map-marker-alt'></i>
                                                    </button>
                                                    <button
                                                        className={`btn btn-sm btn-outline-${customer.is_active ? 'warning' : 'success'}`}
                                                        onClick={() => toggleCustomerStatus(customer)}
                                                        title={customer.is_active ? 'Deactivate' : 'Activate'}
                                                    >
                                                        <i className={`fas fa-${customer.is_active ? 'ban' : 'check'}`}></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    </div>

                    {/* Pagination */}
                    {pagination.total_pages > 1 && (
                        <div className='d-flex justify-content-between align-items-center mt-4'>
                            <div className='text-muted small'>
                                Page {pagination.current_page} of {pagination.total_pages}
                            </div>
                            <nav>
                                <ul className='pagination mb-0'>
                                    <li className={`page-item ${!pagination.has_prev_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(1)}
                                            disabled={!pagination.has_prev_page}
                                        >
                                            <i className="fas fa-angle-double-left"></i>
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_prev_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.current_page - 1)}
                                            disabled={!pagination.has_prev_page}
                                        >
                                            Previous
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_next_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.current_page + 1)}
                                            disabled={!pagination.has_next_page}
                                        >
                                            Next
                                        </button>
                                    </li>
                                    <li className={`page-item ${!pagination.has_next_page ? 'disabled' : ''}`}>
                                        <button
                                            className='page-link'
                                            onClick={() => handlePageChange(pagination.total_pages)}
                                            disabled={!pagination.has_next_page}
                                        >
                                            <i className="fas fa-angle-double-right"></i>
                                        </button>
                                    </li>
                                </ul>
                            </nav>
                        </div>
                    )}
                </div>
            </div>

            {/* Add Customer Modal */}
            {showCustomerModal && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)'}} onClick={() => setShowCustomerModal(false)}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content customer-modal'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <h4 className='modal-title mb-0'>
                                    <i className='fas fa-user-plus text-primary me-2'></i>
                                    Add New Customer
                                </h4>
                                <button type='button' className='btn-close' onClick={() => setShowCustomerModal(false)}></button>
                            </div>
                            <div className='modal-body modal-body-scrollable p-4'>
                                <form onSubmit={(e) => { e.preventDefault(); submitCustomer(); }}>
                                    <div className='row g-3'>
                                        {/* ISP Customer ID with Find Button */}
                                        <div className='col-12'>
                                            <div className='isp-customer-field'>
                                                <div className='form-group-mui'>
                                                    <input
                                                        type='text'
                                                        className='form-control form-control-mui'
                                                        id='ispCustomerId'
                                                        value={customerForm.ispCustomerId}
                                                        onChange={(e) => handleCustomerFormChange('ispCustomerId', e.target.value)}
                                                        placeholder=' '
                                                    />
                                                    <label htmlFor='ispCustomerId' className='form-label-mui'>
                                                        <i className='fas fa-id-card text-muted me-2'></i>
                                                        ISP Customer ID
                                                    </label>
                                                </div>
                                                <button
                                                    type='button'
                                                    className='btn btn-sm btn-primary find-btn-small'
                                                    onClick={findCustomerFromBilling}
                                                    disabled={loading || !customerForm.ispCustomerId}
                                                    title="Find Customer"
                                                >
                                                    {loading ? (
                                                        <span className="spinner-border spinner-border-sm" role="status"></span>
                                                    ) : (
                                                        <i className='fas fa-search'></i>
                                                    )}
                                                </button>
                                            </div>
                                        </div>

                                        {/* Name - Full width */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='firstname'
                                                    value={customerForm.firstname}
                                                    onChange={(e) => handleCustomerFormChange('firstname', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='firstname' className='form-label-mui'>
                                                    <i className='fas fa-user text-muted me-2'></i>
                                                    Name *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Email and Mobile */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='email'
                                                    className='form-control form-control-mui'
                                                    id='email'
                                                    value={customerForm.email}
                                                    onChange={(e) => handleCustomerFormChange('email', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='email' className='form-label-mui'>
                                                    <i className='fas fa-envelope text-muted me-2'></i>
                                                    Email *
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='mobile_no'
                                                    value={customerForm.mobile_no}
                                                    onChange={(e) => handleCustomerFormChange('mobile_no', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='mobile_no' className='form-label-mui'>
                                                    <i className='fas fa-phone text-muted me-2'></i>
                                                    Mobile Number *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Gender and Date of Birth */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <select
                                                    className='form-control form-control-mui'
                                                    id='gender'
                                                    value={customerForm.gender}
                                                    onChange={(e) => handleCustomerFormChange('gender', e.target.value)}
                                                    style={{ 
                                                        appearance: 'none',
                                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                                        backgroundPosition: 'right 0.5rem center',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: '1.5em 1.5em',
                                                        paddingRight: '2.5rem'
                                                    }}
                                                >
                                                    <option value=''>Select Gender</option>
                                                    <option value='male'>Male</option>
                                                    <option value='female'>Female</option>
                                                    <option value='other'>Other</option>
                                                </select>
                                                <label htmlFor='gender' className='form-label-mui'>
                                                    <i className='fas fa-venus-mars text-muted me-2'></i>
                                                    Gender
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='date'
                                                    className='form-control form-control-mui'
                                                    id='dob'
                                                    value={customerForm.dob}
                                                    onChange={(e) => handleCustomerFormChange('dob', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='dob' className='form-label-mui'>
                                                    <i className='fas fa-calendar text-muted me-2'></i>
                                                    Date of Birth
                                                </label>
                                            </div>
                                        </div>

                                        {/* Password */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='number'
                                                    className='form-control form-control-mui'
                                                    id='password'
                                                    value={customerForm.password}
                                                    onChange={(e) => handleCustomerFormChange('password', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='password' className='form-label-mui'>
                                                    <i className='fas fa-lock text-muted me-2'></i>
                                                    4 Digit PIN
                                                </label>
                                            </div>
                                        </div>

                                        {/* Active Status */}
                                        <div className='col-md-6 d-flex align-items-center'>
                                            <div className='form-check form-check-modern'>
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    id='is_active'
                                                    checked={customerForm.is_active}
                                                    onChange={(e) => handleCustomerFormChange('is_active', e.target.checked)}
                                                />
                                                <label className='form-check-label' htmlFor='is_active'>
                                                    <i className='fas fa-toggle-on text-success me-2'></i>
                                                    Active Customer
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer customer-modal-footer bg-white border-top sticky-bottom'>
                                <button type='button' className='btn btn-outline-secondary' onClick={() => setShowCustomerModal(false)}>
                                    <i className='fas fa-times me-2'></i>
                                    Cancel
                                </button>
                                <button type='button' className='btn btn-primary btn-modern' onClick={submitCustomer} disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Creating...
                                        </>
                                    ) : (
                                        <>
                                            <i className='fas fa-save me-2'></i>
                                            Create Customer
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Add Address Modal */}
            {showAddressModal && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)'}} onClick={() => setShowAddressModal(false)}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content address-modal'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <h4 className='modal-title mb-0'>
                                    <i className='fas fa-map-marker-alt text-primary me-2'></i>
                                    Add Address for {selectedCustomer?.full_name}
                                </h4>
                                <button type='button' className='btn-close' onClick={() => setShowAddressModal(false)}></button>
                            </div>
                            <div className='modal-body modal-body-scrollable p-4'>
                                <form onSubmit={(e) => { e.preventDefault(); submitAddress(); }}>
                                    <div className='row g-3'>
                                        {/* Area - Full width at top */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <select
                                                    className='form-control form-control-mui'
                                                    id='area'
                                                    value={addressForm.area}
                                                    onChange={(e) => handleAddressFormChange('area', e.target.value)}
                                                    style={{ 
                                                        appearance: 'none',
                                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                                        backgroundPosition: 'right 0.5rem center',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: '1.5em 1.5em',
                                                        paddingRight: '2.5rem'
                                                    }}
                                                >
                                                    <option value=''>Select Area</option>
                                                    {areas.map((option, key) => (
                                                        <option key={key} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor='area' className='form-label-mui'>
                                                    <i className='fas fa-map-marked-alt text-muted me-2'></i>
                                                    Area
                                                </label>
                                            </div>
                                        </div>

                                        {/* House No and Floor No */}
                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='house'
                                                    value={addressForm.house}
                                                    onChange={(e) => handleAddressFormChange('house', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='house' className='form-label-mui'>
                                                    <i className='fas fa-home text-muted me-2'></i>
                                                    House no *
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='floor_no'
                                                    value={addressForm.floor_no}
                                                    onChange={(e) => handleAddressFormChange('floor_no', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='floor_no' className='form-label-mui'>
                                                    <i className='fas fa-layer-group text-muted me-2'></i>
                                                    Floor No
                                                </label>
                                            </div>
                                        </div>

                                        {/* Block/Sector and Flat No */}
                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='block'
                                                    value={addressForm.block}
                                                    onChange={(e) => handleAddressFormChange('block', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='block' className='form-label-mui'>
                                                    <i className='fas fa-building text-muted me-2'></i>
                                                    Block/Sector
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='apartment_no'
                                                    value={addressForm.apartment_no}
                                                    onChange={(e) => handleAddressFormChange('apartment_no', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='apartment_no' className='form-label-mui'>
                                                    <i className='fas fa-door-open text-muted me-2'></i>
                                                    Flat No
                                                </label>
                                            </div>
                                        </div>

                                        {/* Road/Street - Full width */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='street'
                                                    value={addressForm.street}
                                                    onChange={(e) => handleAddressFormChange('street', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='street' className='form-label-mui'>
                                                    <i className='fas fa-road text-muted me-2'></i>
                                                    Road/Street *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Region - Hidden but set default */}
                                        <div className='col-12' style={{display: 'none'}}>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='region'
                                                    value={addressForm.region || 'Chittagong'}
                                                    onChange={(e) => handleAddressFormChange('region', e.target.value)}
                                                />
                                            </div>
                                        </div>

                                        {/* Name */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='firstname'
                                                    value={addressForm.firstname}
                                                    onChange={(e) => handleAddressFormChange('firstname', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='firstname' className='form-label-mui'>
                                                    <i className='fas fa-user text-muted me-2'></i>
                                                    Name *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Phone Number */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='phone_number'
                                                    value={addressForm.phone_number}
                                                    onChange={(e) => handleAddressFormChange('phone_number', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='phone_number' className='form-label-mui'>
                                                    <i className='fas fa-phone text-muted me-2'></i>
                                                    Phone Number *
                                                </label>
                                            </div>
                                        </div>



                                        {/* Default Address Checkbox */}
                                        <div className='col-12'>
                                            <div className='address-options'>
                                                <div className='form-check form-check-modern'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        id='defaultShipping'
                                                        checked={addressForm.is_default_shipping}
                                                        onChange={(e) => handleAddressFormChange('is_default_shipping', e.target.checked)}
                                                    />
                                                    <label className='form-check-label' htmlFor='defaultShipping'>
                                                        <i className='fas fa-shipping-fast text-success me-2'></i>
                                                        Set as Default Shipping Address
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer address-modal-footer bg-white border-top sticky-bottom'>
                                <button type='button' className='btn btn-outline-secondary' onClick={() => setShowAddressModal(false)}>
                                    <i className='fas fa-times me-2'></i>
                                    Cancel
                                </button>
                                <button type='button' className='btn btn-primary btn-modern' onClick={submitAddress} disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Creating...
                                        </>
                                    ) : (
                                        <>
                                            <i className='fas fa-save me-2'></i>
                                            Save Address
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Customer Details Modal */}
            {showDetailsModal && customerDetails && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)'}} onClick={() => setShowDetailsModal(false)}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content customer-details-modal'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <h4 className='modal-title mb-0'>
                                    <i className='fas fa-user-circle text-primary me-2'></i>
                                    Customer Details - {customerDetails.firstname}
                                </h4>
                                <button type='button' className='btn-close' onClick={() => setShowDetailsModal(false)}></button>
                            </div>
                            <div className='modal-body modal-body-scrollable p-4'>
                                <div className='row'>
                                    {/* Customer Information */}
                                    <div className='col-md-6'>
                                        <div className='card h-100'>
                                            <div className='card-header bg-light d-flex justify-content-between align-items-center'>
                                                <h5 className='card-title mb-0'>
                                                    <i className='fas fa-user text-primary me-2'></i>
                                                    Customer Information
                                                </h5>
                                                <button 
                                                    className='btn btn-sm btn-outline-primary'
                                                    onClick={openEditCustomerModal}
                                                >
                                                    <i className='fas fa-edit me-1'></i>
                                                    Edit
                                                </button>
                                            </div>
                                            <div className='card-body'>
                                                <div className='row g-3'>
                                                    <div className='col-12'>
                                                        <div className='info-item'>
                                                            <label className='info-label'>
                                                                <i className='fas fa-user text-muted me-2'></i>
                                                                Full Name
                                                            </label>
                                                            <div className='info-value'>
                                                                {customerDetails.firstname}
                                                            </div>
                                                        </div>
                                                    </div>
                                                    
                                                    <div className='col-md-6'>
                                                        <div className='info-item'>
                                                            <label className='info-label'>
                                                                <i className='fas fa-envelope text-muted me-2'></i>
                                                                Email
                                                            </label>
                                                            <div className='info-value'>
                                                                {customerDetails.email || 'N/A'}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className='info-item'>
                                                            <label className='info-label'>
                                                                <i className='fas fa-phone text-muted me-2'></i>
                                                                Mobile
                                                            </label>
                                                            <div className='info-value'>
                                                                {customerDetails.mobile_no || 'N/A'}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className='info-item'>
                                                            <label className='info-label'>
                                                                <i className='fas fa-venus-mars text-muted me-2'></i>
                                                                Gender
                                                            </label>
                                                            <div className='info-value'>
                                                                {customerDetails.gender || 'N/A'}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className='info-item'>
                                                            <label className='info-label'>
                                                                <i className='fas fa-calendar text-muted me-2'></i>
                                                                Date of Birth
                                                            </label>
                                                            <div className='info-value'>
                                                                {customerDetails.dob ? formatDate(customerDetails.dob) : 'N/A'}
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className='info-item'>
                                                            <label className='info-label'>
                                                                <i className='fas fa-toggle-on text-muted me-2'></i>
                                                                Status
                                                            </label>
                                                            <div className='info-value'>
                                                                <span className={`badge ${getStatusBadge(customerDetails.is_active)}`}>
                                                                    {customerDetails.is_active ? 'Active' : 'Inactive'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className='col-md-6'>
                                                        <div className='info-item'>
                                                            <label className='info-label'>
                                                                <i className='fas fa-clock text-muted me-2'></i>
                                                                Joined Date
                                                            </label>
                                                            <div className='info-value'>
                                                                {customerDetails.created_at ? formatDate(customerDetails.created_at) : 'N/A'}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Delivery Addresses */}
                                    <div className='col-md-6'>
                                        <div className='card h-100'>
                                            <div className='card-header bg-light d-flex justify-content-between align-items-center'>
                                                <h5 className='card-title mb-0'>
                                                    <i className='fas fa-map-marker-alt text-primary me-2'></i>
                                                    Delivery Addresses
                                                </h5>
                                                <button 
                                                    className='btn btn-sm btn-outline-primary'
                                                    onClick={() => {
                                                        setShowDetailsModal(false)
                                                        openAddAddressModal(selectedCustomer)
                                                    }}
                                                >
                                                    <i className='fas fa-plus me-1'></i>
                                                    Add Address
                                                </button>
                                            </div>
                                            <div className='card-body'>
                                                {customerDetails.addresses && customerDetails.addresses.length > 0 ? (
                                                    <div className='addresses-list'>
                                                        {customerDetails.addresses.map((address, index) => (
                                                            <div key={index} className='address-card mb-3'>
                                                                <div className='address-header d-flex justify-content-between align-items-start'>
                                                                    <div className='address-type'>
                                                                        <i className='fas fa-home text-primary me-2'></i>
                                                                        <strong>Address {index + 1}</strong>
                                                                        {address.is_default_shipping && (
                                                                            <span className='badge bg-success ms-2'>Default Shipping</span>
                                                                        )}
                                                                    </div>
                                                                    <button 
                                                                        className='btn btn-sm btn-outline-secondary'
                                                                        onClick={() => openEditAddressModal(address)}
                                                                        title='Edit Address'
                                                                    >
                                                                        <i className='fas fa-edit'></i>
                                                                    </button>
                                                                </div>
                                                                <div className='address-details mt-2'>
                                                                    <div className='address-line'>
                                                                        <i className='fas fa-user text-muted me-2'></i>
                                                                        {address.firstname}
                                                                    </div>
                                                                    <div className='address-line'>
                                                                        <i className='fas fa-home text-muted me-2'></i>
                                                                        {address.house && `House: ${address.house}, `}
                                                                        {address.floor_no && `Floor: ${address.floor_no}, `}
                                                                        {address.apartment_no && `Flat: ${address.apartment_no}`}
                                                                    </div>
                                                                    <div className='address-line'>
                                                                        <i className='fas fa-road text-muted me-2'></i>
                                                                        {address.street}
                                                                        {address.block && `, ${address.block}`}
                                                                    </div>
                                                                    <div className='address-line'>
                                                                        <i className='fas fa-map-marked-alt text-muted me-2'></i>
                                                                        {address.area}, {address.region}
                                                                        {address.postcode && ` - ${address.postcode}`}
                                                                    </div>
                                                                    <div className='address-line'>
                                                                        <i className='fas fa-phone text-muted me-2'></i>
                                                                        {address.phone_number}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>
                                                ) : (
                                                    <div className='text-center py-4'>
                                                        <i className='fas fa-map-marker-alt text-muted fa-3x mb-3'></i>
                                                        <p className='text-muted mb-3'>No delivery addresses found</p>
                                                        <button 
                                                            className='btn btn-primary btn-sm'
                                                            onClick={() => {
                                                                setShowDetailsModal(false)
                                                                openAddAddressModal(selectedCustomer)
                                                            }}
                                                        >
                                                            <i className='fas fa-plus me-2'></i>
                                                            Add First Address
                                                        </button>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className='modal-footer bg-white border-top sticky-bottom'>
                                <button type='button' className='btn btn-outline-secondary' onClick={() => setShowDetailsModal(false)}>
                                    <i className='fas fa-times me-2'></i>
                                    Close
                                </button>
                                <button 
                                    type='button' 
                                    className='btn btn-primary'
                                    onClick={() => {
                                        setShowDetailsModal(false)
                                        openAddAddressModal(selectedCustomer)
                                    }}
                                >
                                    <i className='fas fa-plus me-2'></i>
                                    Add Address
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Customer Modal */}
            {showEditCustomerModal && customerDetails && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060}} onClick={closeEditCustomerModal}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content customer-modal'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <h4 className='modal-title mb-0'>
                                    <i className='fas fa-user-edit text-primary me-2'></i>
                                    Edit Customer - {customerDetails.firstname}
                                </h4>
                                <button type='button' className='btn-close' onClick={closeEditCustomerModal}></button>
                            </div>
                            <div className='modal-body modal-body-scrollable p-4'>
                                <form onSubmit={(e) => { e.preventDefault(); submitCustomer(); }}>
                                    <div className='row g-3'>
                                        {/* Name - Full width */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editFirstname'
                                                    value={customerForm.firstname}
                                                    onChange={(e) => handleCustomerFormChange('firstname', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='editFirstname' className='form-label-mui'>
                                                    <i className='fas fa-user text-muted me-2'></i>
                                                    Name *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Email and Mobile */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='email'
                                                    className='form-control form-control-mui'
                                                    id='editEmail'
                                                    value={customerForm.email}
                                                    onChange={(e) => handleCustomerFormChange('email', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='editEmail' className='form-label-mui'>
                                                    <i className='fas fa-envelope text-muted me-2'></i>
                                                    Email *
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editMobileNo'
                                                    value={customerForm.mobile_no}
                                                    onChange={(e) => handleCustomerFormChange('mobile_no', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='editMobileNo' className='form-label-mui'>
                                                    <i className='fas fa-phone text-muted me-2'></i>
                                                    Mobile Number *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Gender and Date of Birth */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <select
                                                    className='form-control form-control-mui'
                                                    id='editGender'
                                                    value={customerForm.gender}
                                                    onChange={(e) => handleCustomerFormChange('gender', e.target.value)}
                                                    style={{ 
                                                        appearance: 'none',
                                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                                        backgroundPosition: 'right 0.5rem center',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: '1.5em 1.5em',
                                                        paddingRight: '2.5rem'
                                                    }}
                                                >
                                                    <option value=''>Select Gender</option>
                                                    <option value='male'>Male</option>
                                                    <option value='female'>Female</option>
                                                    <option value='other'>Other</option>
                                                </select>
                                                <label htmlFor='editGender' className='form-label-mui'>
                                                    <i className='fas fa-venus-mars text-muted me-2'></i>
                                                    Gender
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='date'
                                                    className='form-control form-control-mui'
                                                    id='editDob'
                                                    value={customerForm.dob}
                                                    onChange={(e) => handleCustomerFormChange('dob', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='editDob' className='form-label-mui'>
                                                    <i className='fas fa-calendar text-muted me-2'></i>
                                                    Date of Birth
                                                </label>
                                            </div>
                                        </div>

                                        {/* PIN */}
                                        <div className='col-md-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='number'
                                                    className='form-control form-control-mui'
                                                    id='editPassword'
                                                    value={customerForm.password}
                                                    onChange={(e) => handleCustomerFormChange('password', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='editPassword' className='form-label-mui'>
                                                    <i className='fas fa-lock text-muted me-2'></i>
                                                    4 Digit PIN (Leave blank to keep current)
                                                </label>
                                            </div>
                                        </div>

                                        {/* Active Status */}
                                        <div className='col-md-6 d-flex align-items-center'>
                                            <div className='form-check form-check-modern'>
                                                <input
                                                    className='form-check-input'
                                                    type='checkbox'
                                                    id='editIsActive'
                                                    checked={customerForm.is_active}
                                                    onChange={(e) => handleCustomerFormChange('is_active', e.target.checked)}
                                                />
                                                <label className='form-check-label' htmlFor='editIsActive'>
                                                    <i className='fas fa-toggle-on text-success me-2'></i>
                                                    Active Customer
                                                </label>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer customer-modal-footer bg-white border-top sticky-bottom'>
                                <button type='button' className='btn btn-outline-secondary' onClick={closeEditCustomerModal}>
                                    <i className='fas fa-times me-2'></i>
                                    Cancel
                                </button>
                                <button type='button' className='btn btn-primary btn-modern' onClick={submitCustomer} disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <i className='fas fa-save me-2'></i>
                                            Update Customer
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Edit Address Modal */}
            {showEditAddressModal && editingAddress && (
                <div className='modal show modal-adaptive' style={{display: 'block', backgroundColor: 'rgba(0,0,0,0.6)', zIndex: 1060}} onClick={closeEditAddressModal}>
                    <div className='modal-dialog modal-dialog-adaptive' onClick={(e) => e.stopPropagation()}>
                        <div className='modal-content address-modal'>
                            <div className='modal-header border-bottom sticky-top bg-white'>
                                <h4 className='modal-title mb-0'>
                                    <i className='fas fa-map-marker-alt text-primary me-2'></i>
                                    Edit Address - {editingAddress.firstname}
                                </h4>
                                <button type='button' className='btn-close' onClick={closeEditAddressModal}></button>
                            </div>
                            <div className='modal-body modal-body-scrollable p-4'>
                                <form onSubmit={(e) => { e.preventDefault(); submitAddress(); }}>
                                    <div className='row g-3'>
                                        {/* Area - Full width at top */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <select
                                                    className='form-control form-control-mui'
                                                    id='editArea'
                                                    value={addressForm.area}
                                                    onChange={(e) => handleAddressFormChange('area', e.target.value)}
                                                    style={{ 
                                                        appearance: 'none',
                                                        backgroundImage: 'url("data:image/svg+xml,%3csvg xmlns=\'http://www.w3.org/2000/svg\' fill=\'none\' viewBox=\'0 0 20 20\'%3e%3cpath stroke=\'%236b7280\' stroke-linecap=\'round\' stroke-linejoin=\'round\' stroke-width=\'1.5\' d=\'m6 8 4 4 4-4\'/%3e%3c/svg%3e")',
                                                        backgroundPosition: 'right 0.5rem center',
                                                        backgroundRepeat: 'no-repeat',
                                                        backgroundSize: '1.5em 1.5em',
                                                        paddingRight: '2.5rem'
                                                    }}
                                                >
                                                    <option value=''>Select Area</option>
                                                    {areas.map((option, key) => (
                                                        <option key={key} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                                <label htmlFor='editArea' className='form-label-mui'>
                                                    <i className='fas fa-map-marked-alt text-muted me-2'></i>
                                                    Area
                                                </label>
                                            </div>
                                        </div>

                                        {/* House No and Floor No */}
                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editHouse'
                                                    value={addressForm.house}
                                                    onChange={(e) => handleAddressFormChange('house', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='editHouse' className='form-label-mui'>
                                                    <i className='fas fa-home text-muted me-2'></i>
                                                    House no *
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editFloorNo'
                                                    value={addressForm.floor_no}
                                                    onChange={(e) => handleAddressFormChange('floor_no', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='editFloorNo' className='form-label-mui'>
                                                    <i className='fas fa-layer-group text-muted me-2'></i>
                                                    Floor No
                                                </label>
                                            </div>
                                        </div>

                                        {/* Block/Sector and Flat No */}
                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editBlock'
                                                    value={addressForm.block}
                                                    onChange={(e) => handleAddressFormChange('block', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='editBlock' className='form-label-mui'>
                                                    <i className='fas fa-building text-muted me-2'></i>
                                                    Block/Sector
                                                </label>
                                            </div>
                                        </div>

                                        <div className='col-6'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editApartmentNo'
                                                    value={addressForm.apartment_no}
                                                    onChange={(e) => handleAddressFormChange('apartment_no', e.target.value)}
                                                    placeholder=' '
                                                />
                                                <label htmlFor='editApartmentNo' className='form-label-mui'>
                                                    <i className='fas fa-door-open text-muted me-2'></i>
                                                    Flat No
                                                </label>
                                            </div>
                                        </div>

                                        {/* Road/Street - Full width */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editStreet'
                                                    value={addressForm.street}
                                                    onChange={(e) => handleAddressFormChange('street', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='editStreet' className='form-label-mui'>
                                                    <i className='fas fa-road text-muted me-2'></i>
                                                    Road/Street *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Name */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editAddressFirstname'
                                                    value={addressForm.firstname}
                                                    onChange={(e) => handleAddressFormChange('firstname', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='editAddressFirstname' className='form-label-mui'>
                                                    <i className='fas fa-user text-muted me-2'></i>
                                                    Name *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Phone Number */}
                                        <div className='col-12'>
                                            <div className='form-group-mui'>
                                                <input
                                                    type='text'
                                                    className='form-control form-control-mui'
                                                    id='editPhoneNumber'
                                                    value={addressForm.phone_number}
                                                    onChange={(e) => handleAddressFormChange('phone_number', e.target.value)}
                                                    placeholder=' '
                                                    required
                                                />
                                                <label htmlFor='editPhoneNumber' className='form-label-mui'>
                                                    <i className='fas fa-phone text-muted me-2'></i>
                                                    Phone Number *
                                                </label>
                                            </div>
                                        </div>

                                        {/* Default Address Checkbox */}
                                        <div className='col-12'>
                                            <div className='address-options'>
                                                <div className='form-check form-check-modern'>
                                                    <input
                                                        className='form-check-input'
                                                        type='checkbox'
                                                        id='editDefaultShipping'
                                                        checked={addressForm.is_default_shipping}
                                                        onChange={(e) => handleAddressFormChange('is_default_shipping', e.target.checked)}
                                                    />
                                                    <label className='form-check-label' htmlFor='editDefaultShipping'>
                                                        <i className='fas fa-shipping-fast text-success me-2'></i>
                                                        Set as Default Shipping Address
                                                    </label>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                            <div className='modal-footer address-modal-footer bg-white border-top sticky-bottom'>
                                <button type='button' className='btn btn-outline-secondary' onClick={closeEditAddressModal}>
                                    <i className='fas fa-times me-2'></i>
                                    Cancel
                                </button>
                                <button type='button' className='btn btn-primary btn-modern' onClick={submitAddress} disabled={loading}>
                                    {loading ? (
                                        <>
                                            <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <i className='fas fa-save me-2'></i>
                                            Update Address
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <style jsx>{`
                /* PaymentList.js Modal Styles - Enhanced Modal Styles */
                .modal-adaptive {
                    padding: 0;
                }
                
                .modal-dialog-adaptive {
                    margin: 0;
                    display: flex;
                    flex-direction: column;
                }
                
                .modal-content {
                    display: flex;
                    flex-direction: column;
                    border: 0;
                }
                
                .sticky-top {
                    position: sticky;
                    top: 0;
                    z-index: 1020;
                }
                
                .sticky-bottom {
                    position: sticky;
                    bottom: 0;
                    z-index: 1020;
                }
                
                .modal-body-scrollable {
                    flex: 1;
                    overflow-y: auto;
                    padding-bottom: 2rem;
                }

                /* Mobile specific styles - Full screen */
                @media (max-width: 768px) {
                    .modal-adaptive {
                        padding: 0;
                    }
                    
                    .modal-dialog-adaptive {
                        width: 100vw;
                        height: 100vh;
                        margin: 0;
                        max-width: none;
                    }
                    
                    .modal-content {
                        height: 100vh;
                        border-radius: 0;
                    }
                    
                    .modal-body-scrollable {
                        padding: 1rem !important;
                        padding-bottom: 2rem !important;
                    }
                    
                    .modal-header {
                        padding: 0.75rem 1rem;
                    }
                    
                    .modal-footer {
                        padding: 0.75rem 1rem;
                        flex-wrap: wrap;
                        gap: 0.5rem;
                    }
                    
                    .modal-footer .btn {
                        flex: 1;
                        min-width: auto;
                    }
                }
                
                /* Desktop styles - Medium modal */
                @media (min-width: 769px) {
                    .modal-adaptive {
                        padding: 0;
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        min-height: 100vh;
                    }
                    
                    .modal-dialog-adaptive {
                        max-width: 600px;
                        width: 85%;
                        margin: auto;
                        height: auto;
                        max-height: 85vh;
                        position: relative;
                        transform: none;
                        top: auto;
                        left: auto;
                    }
                    
                    .modal-content {
                        border-radius: 0.5rem;
                        box-shadow: 0 0.5rem 2rem rgba(0, 0, 0, 0.15);
                        height: auto;
                        max-height: 85vh;
                        display: flex;
                        flex-direction: column;
                    }
                    
                    .modal-body-scrollable {
                        padding: 1.5rem !important;
                        max-height: calc(85vh - 120px);
                        flex: 1;
                        overflow-y: auto;
                    }
                    
                    .modal-header {
                        border-radius: 0.5rem 0.5rem 0 0;
                        padding: 1rem 1.5rem;
                        flex-shrink: 0;
                    }
                    
                    .modal-footer {
                        border-radius: 0 0 0.5rem 0.5rem;
                        padding: 1rem 1.5rem;
                        flex-shrink: 0;
                    }
                }

                /* Large desktop screens */
                @media (min-width: 1200px) {
                    .modal-dialog-adaptive {
                        max-width: 700px;
                        width: 60%;
                    }
                }

              

           

                    /* Ensure modal dialog takes full screen */
                    .modal-dialog {
                        margin: 0;
                        max-width: 100%;
                        height: 100vh;
                    }

                    .modal-lg {
                        max-width: 100%;
                    }

                    .modal-xl {
                        max-width: 100%;
                    }
                }

                .address-modal .modal-header, .customer-modal .modal-header, .customer-details-modal .modal-header {
                    background: white;
                    color: #374151;
                    border-radius: 12px 12px 0 0;
                    border-bottom: 1px solid #e5e7eb;
                    padding: 1.5rem 2rem;
                }

                .address-modal .modal-header .modal-title, .customer-modal .modal-header .modal-title, .customer-details-modal .modal-header .modal-title {
                    font-weight: 600;
                    font-size: 1.2rem;
                }

                .address-modal .modal-header .btn-close, .customer-modal .modal-header .btn-close, .customer-details-modal .modal-header .btn-close {
                    filter: none;
                    opacity: 0.6;
                }

                .address-modal .modal-header .btn-close:hover, .customer-modal .modal-header .btn-close:hover, .customer-details-modal .modal-header .btn-close:hover {
                    opacity: 1;
                }

                .address-modal .modal-body, .customer-modal .modal-body, .customer-details-modal .modal-body {
                    background-color: white;
                    padding: 2rem;
                }

                .form-control-modern {
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    padding: 0.75rem 1rem;
                    font-size: 14px;
                    transition: all 0.2s ease;
                    background-color: white;
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    box-sizing: border-box;
                    outline: none;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    text-rendering: optimizeLegibility;
                    color: #374151;
                    line-height: 1.5;
                }

                .form-control-modern select,
                .form-control-modern option {
                    background-color: white;
                    color: #495057;
                }



                .form-control-modern:focus {
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                    background-color: white;
                    outline: none;
                }

                .form-control-modern:hover {
                    border-color: #9ca3af;
                }

                .form-group-modern {
                    margin-bottom: 1rem;
                    width: 100%;
                }

                .form-label-modern {
                    display: block;
                    margin-bottom: 0.5rem;
                    color: #374151;
                    font-size: 14px;
                    font-weight: 500;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    text-rendering: optimizeLegibility;
                }

                /* Material-UI Style Floating Labels */
                .form-group-mui {
                    position: relative;
                    margin-bottom: 1.5rem;
                    width: 100%;
                }

                .form-control-mui {
                    border: 1px solid #d1d5db;
                    border-radius: 6px;
                    padding: 1rem 1rem 0.5rem 1rem;
                    font-size: 14px;
                    transition: all 0.2s ease;
                    background-color: white;
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    box-sizing: border-box;
                    outline: none;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    text-rendering: optimizeLegibility;
                    color: #374151;
                    line-height: 1.5;
                }

                .form-control-mui:focus {
                    border-color: #3b82f6;
                    box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
                    background-color: white;
                    outline: none;
                }

                .form-control-mui:hover {
                    border-color: #9ca3af;
                }

                .form-label-mui {
                    position: absolute;
                    top: 50%;
                    left: 1rem;
                    transform: translateY(-50%);
                    color: #6b7280;
                    font-size: 14px;
                    font-weight: 400;
                    pointer-events: none;
                    transition: all 0.2s ease;
                    background-color: white;
                    padding: 0 0.25rem;
                    z-index: 2;
                    white-space: nowrap;
                    -webkit-font-smoothing: antialiased;
                    -moz-osx-font-smoothing: grayscale;
                    text-rendering: optimizeLegibility;
                }

                /* Floating label animation */
                .form-control-mui:focus ~ .form-label-mui,
                .form-control-mui:not(:placeholder-shown) ~ .form-label-mui {
                    top: -0.5rem;
                    left: 0.75rem;
                    transform: scale(0.8);
                    color: #3b82f6;
                    font-weight: 500;
                    background-color: white;
                    padding: 0 0.5rem;
                }

                /* Special handling for select dropdowns */
                .form-control-mui option:first-child {
                    display: none;
                }

                .form-control-mui:valid ~ .form-label-mui,
                .form-control-mui[value]:not([value=""]) ~ .form-label-mui {
                    top: -0.5rem;
                    left: 0.75rem;
                    transform: scale(0.8);
                    color: #3b82f6;
                    font-weight: 500;
                    background-color: white;
                    padding: 0 0.5rem;
                }

                .form-control-modern::placeholder {
                    color: #9ca3af;
                    font-size: 14px;
                    opacity: 0.7;
                }

                .form-control-modern:focus::placeholder {
                    color: #d1d5db;
                    opacity: 0.8;
                }

                .form-control-modern select,
                .form-control-modern option {
                    background-color: white;
                    color: #495057;
                }

                .address-options {
                    background: white;
                    padding: 1.5rem;
                    border-radius: 10px;
                    border: 2px solid #e9ecef;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                }

                .form-check-modern {
                    display: flex;
                    align-items: center;
                    padding: 0.5rem 0;
                }

                .form-check-modern .form-check-input {
                    width: 1.2rem;
                    height: 1.2rem;
                    margin-right: 0.75rem;
                    border: 2px solid #3D9BD6;
                    border-radius: 4px;
                    background-color: white;
                    transition: all 0.2s ease;
                }

                .form-check-modern .form-check-input:checked {
                    background-color: #3D9BD6;
                    border-color: #3D9BD6;
                }

                .form-check-modern .form-check-input:focus {
                    box-shadow: 0 0 0 0.2rem rgba(61, 155, 214, 0.25);
                }

                .form-check-modern .form-check-label {
                    font-size: 14px;
                    font-weight: 500;
                    color: #495057;
                    cursor: pointer;
                    display: flex;
                    align-items: center;
                    margin-bottom: 0;
                }

                .address-modal-footer, .customer-modal-footer {
                    background-color: white;
                    border-top: 1px solid #e9ecef;
                    border-radius: 0 0 12px 12px;
                    padding: 1.5rem 2rem;
                    display: flex;
                    justify-content: flex-end;
                    gap: 1rem;
                }

                .btn-modern {
                    border-radius: 8px;
                    padding: 0.625rem 1.5rem;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.3s ease;
                    border: none;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .btn-modern:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                }

                .btn-modern:active {
                    transform: translateY(0);
                }

                .btn-outline-secondary {
                    border: 2px solid #6c757d;
                    color: #6c757d;
                    background-color: transparent;
                    border-radius: 8px;
                    padding: 0.625rem 1.5rem;
                    font-weight: 500;
                    font-size: 14px;
                    transition: all 0.3s ease;
                }

                .btn-outline-secondary:hover {
                    background-color: #6c757d;
                    color: white;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 12px rgba(108, 117, 125, 0.3);
                }

                /* Enhanced Mobile Modal Adjustments */
                @media (max-width: 768px) {
                    .address-modal .modal-body, 
                    .customer-modal .modal-body {
                        padding: 1rem 1.5rem;
                        padding-top: 5.5rem;
                        padding-bottom: 5.5rem;
                    }

                    .address-modal-footer, 
                    .customer-modal-footer {
                        padding: 1rem 1.5rem;
                        flex-direction: row;
                        gap: 0.75rem;
                        justify-content: stretch;
                    }

                    .address-modal-footer .btn, 
                    .customer-modal-footer .btn {
                        flex: 1;
                        margin-bottom: 0;
                        min-height: 2.75rem;
                        font-size: 0.9rem;
                        font-weight: 600;
                    }

                    .form-label-modern, .form-label-mui {
                        font-size: 13px;
                    }

                    .form-control-modern, .form-control-mui {
                        font-size: 13px;
                        min-height: 2.5rem;
                    }

                    /* Modal title adjustments for mobile */
                    .modal-title {
                        font-size: 1.1rem;
                        font-weight: 600;
                        line-height: 1.3;
                    }

                    /* Close button mobile adjustments */
                    .btn-close {
                        padding: 0.5rem;
                        font-size: 1.2rem;
                    }
                }

                /* Extra small mobile adjustments */
                @media (max-width: 576px) {
                    .address-modal .modal-body, 
                    .customer-modal .modal-body {
                        padding: 0.75rem 1rem;
                        padding-top: 5.5rem;
                        padding-bottom: 5.5rem;
                    }

                    .address-modal-footer, 
                    .customer-modal-footer {
                        padding: 0.75rem 1rem;
                        flex-direction: column;
                        gap: 0.5rem;
                    }

                    .address-modal-footer .btn, 
                    .customer-modal-footer .btn {
                        width: 100%;
                        min-height: 2.5rem;
                        font-size: 0.875rem;
                    }

                    .modal-title {
                        font-size: 1rem;
                    }

                    .form-control-modern, .form-control-mui {
                        font-size: 12px;
                        min-height: 2.25rem;
                    }

                    .form-label-modern, .form-label-mui {
                        font-size: 12px;
                    }
                }

                /* Icons styling */
                .text-muted {
                    opacity: 0.6;
                }

                .form-label-modern i {
                    margin-right: 0.5rem;
                }

                /* Focus and hover effects */
                .form-group-modern:hover .form-label-modern {
                    color: #3D9BD6;
                }

                .form-control-modern:focus + .form-label-modern i,
                .form-group-modern:hover .form-label-modern i {
                    color: #3D9BD6;
                }

                /* Mobile Customer Cards */
                .customer-cards {
                    display: flex;
                    flex-direction: column;
                    gap: 1rem;
                }
                
                .customer-card {
                    background: white;
                    border: 1px solid #e9ecef;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                    transition: all 0.3s ease;
                    position: relative;
                    overflow: hidden;
                }
                
                .customer-card:hover {
                    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
                    transform: translateY(-1px);
                    border-color: #007bff;
                }
                
                .customer-card-header {
                    display: flex;
                    justify-content: space-between;
                    align-items: flex-start;
                    margin-bottom: 0.75rem;
                    padding-bottom: 0.75rem;
                    border-bottom: 1px solid #f1f3f4;
                }
                
                .customer-name {
                    flex: 1;
                }
                
                .customer-name strong {
                    font-size: 1.1rem;
                    color: #212529;
                    display: block;
                    margin-bottom: 0.25rem;
                }

                .customer-ids {
                    display: flex;
                    flex-direction: column;
                    gap: 0.25rem;
                }

                .customer-ids .badge {
                    font-size: 0.75rem;
                    align-self: flex-start;
                }
                
                .customer-status .badge {
                    font-size: 0.75rem;
                    padding: 0.375rem 0.75rem;
                }
                
                .customer-card-body {
                    margin-bottom: 0.75rem;
                }
                
                .customer-info-row {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    margin-bottom: 0.5rem;
                    min-height: 1.5rem;
                }
                
                .customer-info-row:last-child {
                    margin-bottom: 0;
                }
                
                .info-label-mobile {
                    font-size: 0.8rem;
                    font-weight: 600;
                    color: #6c757d;
                    flex-shrink: 0;
                    min-width: fit-content;
                    display: flex;
                    align-items: center;
                }
                
                .info-value-mobile {
                    font-size: 0.85rem;
                    color: #212529;
                    font-weight: 500;
                    text-align: right;
                    flex: 1;
                    margin-left: 0.5rem;
                    word-break: break-word;
                }
                
                .customer-card-footer {
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    padding-top: 0.75rem;
                    border-top: 1px solid #f1f3f4;
                }
                
                .customer-date {
                    display: flex;
                    align-items: center;
                    flex: 1;
                }
                
                .customer-actions {
                    display: flex;
                    align-items: center;
                    gap: 0.25rem;
                }
                
                .customer-actions .btn {
                    width: 2.25rem;
                    height: 2.25rem;
                    padding: 0;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                /* Enhanced Card Header for Mobile */
                .card-header-mobile {
                    background: linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%);
                    border-bottom: 1px solid #e9ecef;
                    border-radius: 0.75rem 0.75rem 0 0 !important;
                    padding: 1rem 1.5rem;
                    position: relative;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                }

                .card-title .card-label {
                    color: #212529;
                    font-weight: 600;
                    margin: 0;
                    font-size: 1.25rem;
                }

                .card-toolbar-mobile {
                    display: flex;
                    gap: 0.5rem;
                    align-items: center;
                    flex-wrap: wrap;
                }

                .btn-mobile {
                    display: flex;
                    align-items: center;
                    gap: 0.5rem;
                    border-radius: 0.5rem;
                    font-weight: 500;
                    font-size: 0.875rem;
                    padding: 0.5rem 1rem;
                    border: none;
                    transition: all 0.3s ease;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
                }

                .btn-mobile:hover {
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
                }

                .btn-mobile i {
                    font-size: 0.875rem;
                }

                /* Enhanced Mobile Filters */
                .filters-container-mobile {
                    background: #f8f9fa;
                    border-radius: 0.75rem;
                    padding: 1rem;
                    border: 1px solid #e9ecef;
                }

                .mobile-filters {
                    width: 100%;
                }

                .mobile-search-wrapper {
                    width: 100%;
                }

                .form-control-mobile-search {
                    height: 3rem;
                    border-radius: 1.5rem;
                    border: 2px solid #e9ecef;
                    padding-left: 3rem;
                    padding-right: 1rem;
                    font-size: 1rem;
                    background: white;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                    transition: all 0.3s ease;
                    font-weight: 400;
                }

                .form-control-mobile-search:focus {
                    border-color: #007bff;
                    box-shadow: 0 4px 12px rgba(0, 123, 255, 0.15);
                    transform: translateY(-1px);
                    outline: none;
                }

                .search-icon-mobile {
                    position: absolute;
                    left: 1rem;
                    top: 50%;
                    transform: translateY(-50%);
                    color: #6c757d;
                    font-size: 1.1rem;
                    pointer-events: none;
                }

                .search-loading-mobile {
                    position: absolute;
                    right: 1rem;
                    top: 50%;
                    transform: translateY(-50%);
                }

                .mobile-filter-row {
                    display: flex;
                    gap: 0.75rem;
                    width: 100%;
                }

                .mobile-filter-item {
                    flex: 1;
                    display: flex;
                    flex-direction: column;
                    gap: 0.5rem;
                }

                .filter-label-mobile {
                    font-size: 0.875rem;
                    font-weight: 600;
                    color: #495057;
                    margin-bottom: 0;
                }

                .form-select-mobile {
                    height: 2.75rem;
                    border-radius: 0.75rem;
                    border: 2px solid #e9ecef;
                    background: white;
                    font-size: 0.875rem;
                    font-weight: 500;
                    padding: 0.5rem 0.75rem;
                    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
                    transition: all 0.3s ease;
                }

                .form-select-mobile:focus {
                    border-color: #007bff;
                    box-shadow: 0 4px 8px rgba(0, 123, 255, 0.15);
                    outline: none;
                }

                /* Mobile Results Summary Enhancement */
                .text-muted.small {
                    background: rgba(108, 117, 125, 0.1);
                    padding: 0.75rem 1rem;
                    border-radius: 0.5rem;
                    font-weight: 500;
                    text-align: center;
                    font-size: 0.875rem;
                    color: #495057;
                    border: 1px solid rgba(108, 117, 125, 0.1);
                }

                /* Mobile responsive adjustments */
                @media (max-width: 768px) {
                    /* Card Header Mobile */
                    .card-header-mobile {
                        padding: 1rem;
                        flex-direction: column;
                        align-items: stretch;
                        gap: 1rem;
                    }

                    .card-toolbar-mobile {
                        width: 100%;
                        justify-content: stretch;
                        gap: 0.5rem;
                    }

                    .btn-mobile {
                        flex: 1;
                        justify-content: center;
                        padding: 0.75rem 1rem;
                        font-size: 0.875rem;
                        min-height: 2.5rem;
                    }

                    .btn-text {
                        display: inline;
                    }

                    /* Filter Container Mobile */
                    .filters-container-mobile {
                        padding: 0.75rem;
                        margin: 0 -0.25rem 1rem -0.25rem;
                    }

                    .mobile-search-wrapper {
                        margin-bottom: 1rem;
                    }

                    .form-control-mobile-search {
                        height: 2.75rem;
                        font-size: 0.95rem;
                        padding-left: 2.75rem;
                    }

                    .search-icon-mobile {
                        left: 0.875rem;
                        font-size: 1rem;
                    }

                    .mobile-filter-row {
                        gap: 0.5rem;
                    }

                    .filter-label-mobile {
                        font-size: 0.8rem;
                    }

                    .form-select-mobile {
                        height: 2.5rem;
                        font-size: 0.8rem;
                        padding: 0.375rem 0.625rem;
                    }

                    /* Results Summary Mobile */
                    .text-muted.small {
                        padding: 0.5rem 0.75rem;
                        font-size: 0.8rem;
                        margin: 0 -0.25rem 1rem -0.25rem;
                    }
                }

                @media (max-width: 576px) {
                    /* Extra Small Mobile */
                    .card-header-mobile {
                        padding: 0.75rem;
                        border-radius: 0.5rem 0.5rem 0 0 !important;
                    }

                    .card-title .card-label {
                        font-size: 1.1rem;
                        text-align: center;
                    }

                    .btn-mobile {
                        padding: 0.625rem 0.75rem;
                        font-size: 0.8rem;
                        min-height: 2.25rem;
                    }

                    .btn-mobile .btn-text {
                        font-size: 0.8rem;
                    }

                    .filters-container-mobile {
                        padding: 0.5rem;
                        border-radius: 0.5rem;
                    }

                    .form-control-mobile-search {
                        height: 2.5rem;
                        font-size: 0.9rem;
                        padding-left: 2.5rem;
                        border-radius: 1.25rem;
                    }

                    .search-icon-mobile {
                        left: 0.75rem;
                        font-size: 0.9rem;
                    }

                    .mobile-filter-row {
                        flex-direction: column;
                        gap: 0.75rem;
                    }

                    .mobile-filter-item {
                        width: 100%;
                    }

                    .filter-label-mobile {
                        font-size: 0.75rem;
                    }

                    .form-select-mobile {
                        height: 2.25rem;
                        font-size: 0.75rem;
                        border-radius: 0.5rem;
                    }

                    .text-muted.small {
                        padding: 0.5rem;
                        font-size: 0.75rem;
                        border-radius: 0.375rem;
                    }

                    .customer-card {
                        padding: 0.75rem;
                        border-radius: 0.5rem;
                    }
                    
                    .customer-name strong {
                        font-size: 1rem;
                    }
                    
                    .info-label-mobile {
                        font-size: 0.75rem;
                    }
                    
                    .info-value-mobile {
                        font-size: 0.8rem;
                    }
                    
                    .customer-info-row {
                        margin-bottom: 0.375rem;
                    }

                    .customer-actions .btn {
                        width: 2rem;
                        height: 2rem;
                        font-size: 0.8rem;
                    }
                }

                /* ISP Customer Field with Small Find Button */
                .isp-customer-field {
                    display: flex;
                    align-items: flex-end;
                    gap: 0.75rem;
                    width: 100%;
                }

                .isp-customer-field .form-group-mui {
                    flex: 1;
                }

                .find-btn-small {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    min-width: 3.25rem;
                    height: 3.25rem;
                    padding: 0.5rem;
                    border-radius: 6px;
                    background-color: #3b82f6;
                    border-color: #3b82f6;
                    color: white;
                    font-size: 0.875rem;
                    transition: all 0.2s ease;
                    flex-shrink: 0;
                    margin-bottom: 1.5rem;
                }

                .find-btn-small:hover:not(:disabled) {
                    background-color: #2563eb;
                    border-color: #2563eb;
                    transform: translateY(-1px);
                    box-shadow: 0 4px 8px rgba(59, 130, 246, 0.3);
                }

                .find-btn-small:disabled {
                    background-color: #9ca3af;
                    border-color: #9ca3af;
                    cursor: not-allowed;
                    opacity: 0.6;
                    transform: none;
                }

                .find-btn-small i {
                    font-size: 0.875rem;
                }

                /* Mobile responsive adjustments */
                @media (max-width: 768px) {
                    .isp-customer-field {
                        gap: 0.5rem;
                    }

                    .find-btn-small {
                        min-width: 3rem;
                        height: 3rem;
                        padding: 0.375rem;
                        font-size: 0.8rem;
                    }

                    .find-btn-small i {
                        font-size: 0.8rem;
                    }
                }

                @media (max-width: 576px) {
                    .isp-customer-field {
                        gap: 0.375rem;
                    }

                    .find-btn-small {
                        min-width: 2.75rem;
                        height: 2.75rem;
                        padding: 0.25rem;
                        font-size: 0.75rem;
                    }

                    .find-btn-small i {
                        font-size: 0.75rem;
                    }
                }

                /* Customer Details Modal Styles */
                .customer-details-modal .modal-dialog {
                    max-width: 900px;
                }

                @media (min-width: 769px) {
                    .customer-details-modal {
                        display: flex !important;
                        align-items: center !important;
                        justify-content: center !important;
                        min-height: 100vh;
                        padding: 0;
                    }

                    .customer-details-modal .modal-dialog {
                        max-width: 800px;
                        width: 85%;
                        margin: auto;
                        position: relative;
                        transform: none;
                        top: auto;
                        left: auto;
                        height: auto;
                        max-height: 85vh;
                    }

                    .customer-details-modal .modal-content {
                        max-height: 85vh;
                        display: flex;
                        flex-direction: column;
                    }
                }

                @media (min-width: 1200px) {
                    .customer-details-modal .modal-dialog {
                        max-width: 900px;
                        width: 70%;
                    }
                }

                .info-item {
                    margin-bottom: 1rem;
                }

                .info-label {
                    font-size: 13px;
                    color: #6b7280;
                    font-weight: 500;
                    margin-bottom: 0.25rem;
                    display: block;
                }

                .info-value {
                    font-size: 14px;
                    color: #374151;
                    font-weight: 500;
                    padding: 0.5rem 0;
                    border-bottom: 1px solid #f3f4f6;
                }

                .address-card {
                    border: 1px solid #e5e7eb;
                    border-radius: 8px;
                    padding: 1rem;
                    background-color: #f9fafb;
                    transition: all 0.2s ease;
                }

                .address-card:hover {
                    border-color: #3b82f6;
                    box-shadow: 0 2px 8px rgba(59, 130, 246, 0.1);
                }

                .address-header {
                    border-bottom: 1px solid #e5e7eb;
                    padding-bottom: 0.5rem;
                    margin-bottom: 0.75rem;
                }

                .address-line {
                    font-size: 13px;
                    color: #4b5563;
                    margin-bottom: 0.25rem;
                    display: flex;
                    align-items: center;
                }

                .addresses-list {
                    max-height: 400px;
                    overflow-y: auto;
                }

                .card-header.bg-light {
                    background-color: #f8f9fa !important;
                    border-bottom: 1px solid #e9ecef;
                }

                /* Responsive adjustments for details modal */
                @media (max-width: 768px) {
                    .customer-details-modal .modal-body {
                        padding: 1rem;
                    }

                    .customer-details-modal .col-md-6 {
                        margin-bottom: 1rem;
                    }

                    .address-card {
                        padding: 0.75rem;
                    }

                    .address-line {
                        font-size: 12px;
                    }
                }
            `}</style>
        </>
    )
}

export default CustomerList 